const LOCAL_HOSTS = new Set(["localhost", "127.0.0.1", "::1", "[::1]"]);
const BACKOFFICE_HOST_PREFIX = "backoffice.";
const ALLOW_PUBLIC_BACKOFFICE_PREVIEW = false;

const normalizeHostname = (value) =>
  String(value || "")
    .trim()
    .toLowerCase();

const stripIpv6Brackets = (value) => {
  const normalized = normalizeHostname(value);

  if (normalized.startsWith("[") && normalized.endsWith("]")) {
    return normalized.slice(1, -1);
  }

  return normalized;
};

export const getCurrentHostname = () => {
  if (typeof window === "undefined") {
    return "";
  }

  return normalizeHostname(window.location.hostname);
};

export const isLocalRuntimeHost = (hostname = getCurrentHostname()) =>
  LOCAL_HOSTS.has(stripIpv6Brackets(hostname));

export const isInternalBackofficeHost = (hostname = getCurrentHostname()) => {
  const normalized = stripIpv6Brackets(hostname);
  return normalized.startsWith(BACKOFFICE_HOST_PREFIX);
};

export const buildSuggestedBackofficeHost = (hostname = getCurrentHostname()) => {
  const normalized = stripIpv6Brackets(hostname);

  if (!normalized || isLocalRuntimeHost(normalized)) {
    return normalized;
  }

  if (isInternalBackofficeHost(normalized)) {
    return normalized;
  }

  const hostWithoutWww = normalized.startsWith("www.")
    ? normalized.slice(4)
    : normalized;

  return hostWithoutWww ? `${BACKOFFICE_HOST_PREFIX}${hostWithoutWww}` : "";
};

export const getBackofficeHostMode = (hostname = getCurrentHostname()) => {
  if (isLocalRuntimeHost(hostname)) {
    return "local";
  }

  if (isInternalBackofficeHost(hostname)) {
    return "internal";
  }

  return "preview";
};

export const isPublicBackofficePreviewEnabled = () =>
  ALLOW_PUBLIC_BACKOFFICE_PREVIEW;

export const canOpenBackofficeOnCurrentHost = (hostname = getCurrentHostname()) =>
  isInternalBackofficeHost(hostname) ||
  isLocalRuntimeHost(hostname) ||
  isPublicBackofficePreviewEnabled();
